import { render, staticRenderFns } from "./base-receipt-save.vue?vue&type=template&id=0ec04599"
import script from "./base-receipt-save.vue?vue&type=script&lang=js"
export * from "./base-receipt-save.vue?vue&type=script&lang=js"
import style0 from "./base-receipt-save.vue?vue&type=style&index=0&id=0ec04599&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports